/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react'
import { withTranslation } from 'react-i18next'
import { useSelector, useDispatch } from 'react-redux'
import styles from './ReviewConfirmation.module.scss'
import FinesListTable from '../../FinesList/components/FinesListTable'
import { postTransactionAction } from 'redux/reducers/apiReducers/postTransactionReducer'
import { screenLoadingAction } from 'redux/actions'
import { useLocation } from 'react-router'
import { useHistory } from 'react-router-dom'
import BackAnchor from '../../../../shared/components/BackAnchor'
import BackNextButtonsGreen from '../../../../shared/components/BackNextButtonsGreen'

const ReviewConfirmationView = ({ t, i18n, setIsError }) => {
  let history = useHistory()

  const [confirmChecked, setConfirmChecked] = useState(false)
  const [checkboxMessage, setCheckbocMessage] = useState(false)
  const [errMsg, setErrMsg] = useState('')
  const dispatch = useDispatch()

  const fines = useSelector((state) => state.app.fines)
  const emailAddress = useSelector((state) => state.app.emailAddress)

  const userIdentifier = useSelector((state) => state.register.uniqueID)

  const [fulfillmentStatusError, setFulfillmentStatusError] = useState()
  const location = useLocation()
  useEffect(() => {
    const params = new URLSearchParams(location.search)
    const fulfillmentStatus = params.get('fulfillmentStatus')
    if (fulfillmentStatus === 'SENTFORPAYMENT') {
      setFulfillmentStatusError('review_confirmation.server_error')
    }
  }, [location])

  const getTransactionData = () => {
    try {
      let businessData = {}
      let fineInformation = {
        fines,
        emailAddress,
      }
      businessData['fineInformation'] = fineInformation
      let data = {}
      data['businessData'] = JSON.stringify(businessData)
      data['businessServiceType'] = 'PAYDOJFINE'
      data['lang'] = i18n.language.toString()
      data['useridentifier'] = userIdentifier.toString()
      return data
    } catch (err) {
      console.log(err)
      throw err
    }
  }

  const confirmationClick = () => {
    try {
      if (confirmChecked) {
        setCheckbocMessage(false)
        dispatch(screenLoadingAction())
        dispatch(postTransactionAction(getTransactionData()))
          .then((res) => {
            let transId = res['data']['id']
            let uuid = res['data']['useridentifier']
            let paymentURL = `/services/transactionservice/api/nspayredirect?transId=${transId}&transOwner=${uuid}`
            dispatch(screenLoadingAction())
            window.location.assign(`${window.location.origin}${paymentURL}`)
          })
          .catch((e) => {
            dispatch(screenLoadingAction())
            console.log(e)
            setErrMsg('review_confirmation.server_error')
          })
      } else {
        setCheckbocMessage(true)
      }
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const backNextProps = {
    prevText: t('review_confirmation.cancel'),
    prevURL: `https://beta.novascotia.ca/pay-fine-ticket`,
    nextText: t('review_confirmation.proceed_to_payment'),
    isNextDisabled: false,
  }

  // const editContactInfoOnClick = () => {
  //   try {
  //     history.push(`/${i18n.language}${t('routes.contact_info')}`)
  //   } catch (e) {
  //     console.log(e)
  //     setIsError(true)
  //   }
  // }

  const contactInfoUrl = window.location.origin + `/${i18n.language}/contact-info`

  const editContactInfoOnClick = () => {
    window.open(contactInfoUrl, '_self')
  }

  const addAnotherFine = () => {
    localStorage.setItem('addAnotherFineClicked', 'reviewConfirm')
    history.push(`/${i18n.language}/fine-info`)
  }

  return (
    <div className="container">
      <BackAnchor />
      <div className="row">
        <div className="col-xs-12">
          <h1>{t('title')}</h1>
        </div>
      </div>
      {fulfillmentStatusError && (
        <div className="row">
          <div className="col-xs-12" style={{ display: 'flex' }}>
            <i
              className={['fa fa-exclamation-circle fa-2x', styles['exclamation_position'], styles['exclamation_color']].join(' ')}
              aria-hidden="true"
            />
            <div className={styles['error_message']} style={{ marginLeft: '1rem' }}>
              <div className="form-group has-error">
                <div>
                  <h3 className="help-block">{t(fulfillmentStatusError)}</h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <div className="row">
        <div className="col-xs-12 col-md-8">
          <h2>{t('review_confirmation.summary_of_fines')}</h2>
        </div>
      </div>

      <div className={styles['content_margin']}>
        <FinesListTable />
        <div className="row">
          <div className="col-xs-12 col-md-8">
            <button className={['btn-lg btn-default-transparent', styles['add_fine_right']].join(' ')} onClick={addAnotherFine}>
              {t('review_confirmation.add_another_fine')}
            </button>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-xs-12 col-md-8">
          <h3 style={{ display: 'inline-block' }}>{t('review_confirmation.contact_information')}</h3>
        </div>
      </div>

      <div className="row">
        <div className="col-xs-12 col-md-8">
          <div>
            <span style={{ display: 'inline-block', 'margin-right': '10px' }}>{t('review_confirmation.email_address')}</span>
            <span className="ex1">{emailAddress}</span>
            <a
              href="#"
              className={[styles['edit_button_right']].join(' ')}
              value={t('review_confirmation.edit')}
              name={t('review_confirmation.edit')}
              onClick={editContactInfoOnClick}
            >
              {t('review_confirmation.edit')}
              <span className="ns-visually-hidden">(ouvre dans un nouvel onglet)</span>
            </a>
          </div>
        </div>
      </div>

      {/* <div className="row">
          <div className="col-xs-12 col-lg-12">
            <h3>{t('review_confirmation.contact_information')}</h3>
            <p>
              {t('review_confirmation.your_transaction_details')}<br /><strong>{emailAddress}</strong>
            </p>
          </div>
        </div> */}
      <div className="row">
        <div className="col-xs-12 col-md-8">
          <h3>{t('review_confirmation.confirmation')}</h3>
          <p>{t('review_confirmation.please_verify')}</p>
          <p>{t('review_confirmation.your_confirmation')}</p>
          <ul>
            <li>{t('review_confirmation.you_consent_to')}</li>
            <li>
              {t('review_confirmation.you_are_in_agreement')}
              <a
                target="_blank"
                rel="noopener noreferrer"
                href={
                  i18n.language === 'en'
                    ? 'https://novascotia.ca/sns/services/help/terms-of-use.asp'
                    : 'https://novascotia.ca/sns/services/help/terms-of-use-fr.asp'
                }
              >
                {t('review_confirmation.terms_of_use')}
                <span className="ns-visually-hidden">(s’ouvre dans un nouvel onglet)</span>
              </a>
              {t('review_confirmation.for_this_transaction')}
            </li>
          </ul>
        </div>
      </div>
      <div className="row">
        <div className="ns-checkboxes__item">
          <input
            class="ns-checkboxes__input"
            type="checkbox"
            id="ConfirmationCheckBox"
            value="confirm_check"
            onChange={(e) => {
              setConfirmChecked(e.currentTarget.checked)
            }}
            onBlur={() => {
              confirmChecked ? setCheckbocMessage(false) : setCheckbocMessage(true)
            }}
            checked={confirmChecked}
          />
          <label className="ns-label ns-checkboxes__label" htmlFor="ConfirmationCheckBox">
            <span className="ns-label-span">
              <b>{t('review_confirmation.yes_information_is_correct')}</b>
            </span>
          </label>
        </div>
        {checkboxMessage && (
          <div className="form-group has-error help-block" style={{ marginLeft: '20px' }}>
            <i
              style={{ margin: '3px 5px 0 0' }}
              className={['fa fa-exclamation-circle', styles['exclamation_color']].join(' ')}
              aria-hidden="true"
            ></i>{' '}
            {t('review_confirmation.confirm_check_error')}
          </div>
        )}
      </div>
      <div className={styles['error_margin']}>
        <BackNextButtonsGreen props={backNextProps} nextOnClick={confirmationClick} />
        {errMsg && (
          <i
            className={['fa fa-exclamation-circle', styles['exclamation_position'], styles['exclamation_color']].join(' ')}
            aria-hidden="true"
          />
        )}
      </div>
      {errMsg && (
        <div className={styles['error_message']}>
          <div className="form-group has-error">
            <div className="help-block">{t(errMsg)}</div>
          </div>
        </div>
      )}
    </div>
  )
}

export default withTranslation('common')(ReviewConfirmationView)
